import { useMutation } from '@apollo/client';
import { SetIntegrationDocument, useGetIntegrationsListQuery as _useGetIntegrationsListQuery, useGetVendorsListQuery as _useGetVendorsListQuery, } from '../generated/graphql-types';
export const useGetIntegrationsListQuery = () => {
    const { data, loading, error, refetch } = _useGetIntegrationsListQuery();
    return {
        data: data?.SpotIQ__getIntegrationsList,
        loading,
        error,
        refetch,
    };
};
export const useGetVendorsListQuery = () => {
    const { data, loading, error, refetch } = _useGetVendorsListQuery();
    return {
        data: data?.SpotIQ__getVendorsList,
        loading,
        error,
        refetch,
    };
};
export const useSetIntegrationMutation = () => {
    const [_setIntegration, { data: result, error, loading }] = useMutation(SetIntegrationDocument);
    return {
        data: result?.SpotIQ__setIntegration,
        error,
        loading,
        setIntegration: (payload) => _setIntegration({
            variables: {
                payload,
            },
        }),
    };
};
//# sourceMappingURL=spotiq-service.js.map